import React, { useContext } from 'react';
import './Hero.css'; // Make sure to create this CSS file
import heroImage from '../static/assets/new_background.jpg'; // Replace with your hero image path
import { ModalContext } from '../App';

const HeroSection = () => {
  const { openModal } = useContext(ModalContext);

  return (
    <section className="hero">
      <img src={heroImage} alt="Hero" className="hero-image" />
      <div className="hero-overlay"></div>
      <div className="hero-content">
        <div className="hero-text">
          <h1>Welcome to Escudero Electrical Contractors LLC</h1>
        </div>
        <button className="quote-button" onClick={openModal}>Get a Quote</button>
      </div>
    </section>
  );
};

export default HeroSection;